import {AlertInformation} from '../../types/interfaces';


export class FetchAlertDetails {
  static readonly type = '[AlertInformation] Fetch All';

  constructor(public payload: AlertInformation) {
  }
}
